import * as Icons from 'Images/newUi/header';
import {
  lensFinderLink,
  storeLink,
  facebookLink,
  twitterLink,
  instagramLink,
  kRAcuvueLink,
  MYDefinePromotionLink,
  showQuiz,
  freeTrialLink,
  lensCareLink,
  oneDayDefineLink,
  vkLink,
  youtubeLink,
  promoLink,
  redirectToEnglish,
  redirectToArabic
} from 'Root/constants';
import { isAuthRequired } from 'Root/utils';
const isAuthEnable = isAuthRequired();

const HeaderConfig = () => ({
  mobileItem: {
    text: 'Shop Now',
    image: Icons.purchaseAlone,
    onClick: 'onOpenBuyOnly',
  },
  items: [
    {
      text: 'Home',
      image: Icons.home,
      path: '/home',
      activeImage: Icons.homeActive,
      onClick: 'toggleMenu',
    },
    {
      text: 'Lens Finder',
      image: Icons.lensfinder,
      activeImage: Icons.lensfinderActive,
      onClick: 'toggleMenu',
      condition: showQuiz,
    },
    {
      text: 'Virtual Mirror',
      image: Icons.vm,
      activeImage: Icons.vmActive,
      path: '/vm',
      onClick: 'showCamPopUp',
    },
    {
      text: 'Shop Now',
      image: Icons.purchase,
      activeImage: Icons.purchaseActive,
      onClick: 'onOpenBuy',
    },
    {
      text: 'Store Locator',
      image: Icons.store,
      activeImage: Icons.storeActive,
      href: storeLink,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: 'Lens Care',
      image: Icons.lenscare,
      activeImage: Icons.lenscareActive,
      path: '/about-lens-care',
      onClick: 'toggleMenu',
    },
    {
      text: 'Share',
      image: Icons.share,
      activeImage: Icons.shareActive,
      href: facebookLink,
      share: true,
      onClick: 'toggleMenu',
    },
    {
      text: 'Logout',
      condition: isAuthEnable,
      image: Icons.poweroff,
      activeImage: Icons.poweroffActive,
      onClick: 'logout',
    },
  ],
});

export const IndonesiaHeaderConfig = () => ({
  mobileItem: {
    text: 'Store Locator',
    image: Icons.purchaseAlone,
    href: process.env.REACT_APP_BUY_FRESH_LENS_EXTERNAL_LINK,
    externalLink: true,
  },
  items: [
    {
      text: 'Beranda',
      image: Icons.home,
      path: '/home',
      activeImage: Icons.homeActive,
      onClick: 'toggleMenu',
    },
    {
      text: 'COBA LENSA VIRTUAL',
      image: Icons.vm,
      activeImage: Icons.vmActive,
      path: '/vm',
      onClick: 'showCamPopUp',
    },
    {
      text: 'PILIH LENSA',
      image: Icons.lensfinder,
      activeImage: Icons.lensfinderActive,
      path: '/quiz',
      onClick: 'toggleMenu',
      additionalClass: 'Kaizen_lensfinder_icon'
    },
    {
      text: 'CARA MERAWAT',
      image: Icons.lenscare,
      activeImage: Icons.lenscareActive,
      path: '/about-lens-care',
      onClick: 'toggleMenu',
    },
    {
      text: 'Belanja Sekarang',
      image: Icons.purchase,
      activeImage: Icons.purchaseActive,
      href: process.env.REACT_APP_BUY_FRESH_LENS_EXTERNAL_LINK,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: 'DOWNLOAD MYACUVUE',
      image: Icons.promotion,
      activeImage: Icons.promotionActive,
      href: promoLink,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: 'TEMUKAN OPTIK',
      image: Icons.store,
      activeImage: Icons.storeActive,
      href: storeLink,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: 'Logout',
      condition: isAuthEnable,
      image: Icons.poweroff,
      activeImage: Icons.poweroffActive,
      onClick: 'logout',
    },
  ],
});

export const JapanHeaderConfig = () => ({
  items: [
    {
      text: 'パーソナルカラー診断',
      image: Icons.lensfinder,
      activeImage: Icons.lensfinderActive,
      path: '/quiz',
      onClick: 'toggleMenu',
      additionalClass: 'Kaizen_lensfinder_icon'
    },
    {
      text: 'バーチャルで装用する',
      image: Icons.vm,
      activeImage: Icons.vmActive,
      path: '/vm',
      onClick: 'showCamPopUp',
      additionalClass: 'Kaizen_vm_icon'
    }
  ],
});

export const VietnamHeaderConfig = () => ({
  mobileItem: {
    text: 'Shop Now',
    image: Icons.purchaseAlone,
    onClick: 'onOpenBuyOnly',
  },
  items: [
    {
      text: 'Trang chủ',
      image: Icons.homeVN,
      path: '/home',
      activeImage: Icons.homeVNActive,
      onClick: 'toggleMenu',
    },
    {
      text: 'Thông tin sản phẩm',
      image: Icons.eyeVN,
      activeImage: Icons.eyeVNActive,
      href: oneDayDefineLink,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: 'Thử nghiệm tròng kính AR',
      image: Icons.vmVN,
      activeImage: Icons.vmVNActive,
      path: '/vm',
      onClick: 'showCamPopUp',
    },
    {
      text: 'Bảo quản tròng kính',
      image: Icons.lenscareVN,
      activeImage: Icons.lenscareVNActive,
      path: '/about-lens-care',
      onClick: 'toggleMenu',
    },
    {
      text: 'Mua hàng trực tuyến',
      image: Icons.bagVN,
      activeImage: Icons.bagVNActive,
      href: process.env.REACT_APP_BUY_ONLINE,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: 'Vui lòng liên hệ với chúng tôi',
      image: Icons.contactUSVN,
      activeImage: Icons.contactUSVNActive,
      href: process.env.REACT_APP_CONTACT_US,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: 'Logout',
      condition: isAuthEnable,
      image: Icons.poweroff,
      activeImage: Icons.poweroffActive,
      onClick: 'logout',
    },
  ],
});


export const KoreaHeaderConfig = () => ({
  mobileItem: {
    text: 'Store Locator',
    image: Icons.storeAlone,
    href: storeLink,
    externalLink: true,
  },
  items: [
    {
      text: '홈으로',
      image: Icons.home,
      path: '/home',
      activeImage: Icons.homeActive,
      onClick: 'toggleMenu',
    },
    {
      text: '아큐브 디파인<sup>®</sup> 상세보기',
      image: Icons.lensfinder,
      activeImage: Icons.lensfinderActive,
      href: lensFinderLink,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: '렌즈 가상 체험',
      image: Icons.vm,
      activeImage: Icons.vmActive,
      path: '/vm',
      onClick: 'showCamPopUp',
    },
    {
      text: '가까운 안경원 찾기',
      image: Icons.store,
      activeImage: Icons.storeActive,
      href: storeLink,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: '콘택트렌즈관리',
      image: Icons.lenscare,
      activeImage: Icons.lenscareActive,
      path: '/about-lens-care',
      onClick: 'toggleMenu',
    },
    {
      text: '공유하기',
      image: Icons.share,
      activeImage: Icons.shareActive,
      href: facebookLink,
      share: true,
      onClick: 'toggleMenu',
    },
    {
      text: '신규가입하고 혜택받기',
      image: Icons.kRAcuvue,
      activeImage: Icons.kRAcuvueActive,
      href: kRAcuvueLink,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: 'Logout',
      condition: isAuthEnable,
      image: Icons.poweroff,
      activeImage: Icons.poweroffActive,
      onClick: 'logout',
    },
  ],
});

export const MalaysiaHeaderConfig = () => ({
  mobileItem: {
    text: 'Store Locator',
    image: Icons.storeAlone,
    href: storeLink,
    externalLink: true,
  },
  items: [
    {
      text: 'Home',
      image: Icons.home,
      path: '/home',
      activeImage: Icons.homeActive,
      onClick: 'toggleMenu',
    },
    {
      text: 'Virtual Mirror',
      image: Icons.vm,
      activeImage: Icons.vmActive,
      path: '/vm',
      onClick: 'showCamPopUp',
    },
    {
      text: 'Lens Care',
      image: Icons.lenscare,
      activeImage: Icons.lenscareActive,
      path: '/about-lens-care',
      onClick: 'toggleMenu',
    },
    {
      text: 'instagram',
      image: Icons.insta,
      activeImage: Icons.instaActive,
      href: instagramLink,
      onClick: 'toggleMenu',
    },
    {
      text: 'Share',
      image: Icons.share,
      activeImage: Icons.shareActive,
      href: facebookLink,
      share: true,
      onClick: 'toggleMenu',
    },
    {
      text: 'DEFINE<sup class="text-small">®</sup> NEW COLORS',
      image: Icons.promotion,
      activeImage: Icons.promotionActive,
      href: MYDefinePromotionLink,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: 'Store Locator',
      image: Icons.store,
      activeImage: Icons.storeActive,
      href: storeLink,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: 'Logout',
      condition: isAuthEnable,
      image: Icons.poweroff,
      activeImage: Icons.poweroffActive,
      onClick: 'logout',
    },
  ],
});

export const AustraliaHeaderConfig = () => ({
  mobileItem: {
    text: 'Store Locator',
    image: Icons.storeAlone,
    href: storeLink,
    externalLink: true,
  },
  items: [
    {
      text: 'Home',
      image: Icons.home,
      path: '/home',
      activeImage: Icons.homeActive,
      onClick: 'toggleMenu',
    },
    {
      text: 'Virtual Mirror',
      image: Icons.vm,
      activeImage: Icons.vmActive,
      path: '/vm',
      onClick: 'showCamPopUp',
    },
    {
      text: 'Beauty Advisor',
      image: Icons.promotion,
      activeImage: Icons.promotionActive,
      path: '/quiz',
      onClick: 'toggleMenu',
    },
    {
      text: 'Lens Care',
      image: Icons.lenscare,
      activeImage: Icons.lenscareActive,
      path: '/about-lens-care',
      onClick: 'toggleMenu',
    },
    {
      text: 'Find ECP',
      image: Icons.store,
      activeImage: Icons.storeActive,
      href: storeLink,
      onClick: 'toggleMenu',
    },
    {
      text: 'Logout',
      condition: isAuthEnable,
      image: Icons.poweroff,
      activeImage: Icons.poweroffActive,
      onClick: 'logout',
    },
  ],
});

export const HongkongHeaderConfig = () => ({
  mobileItem: {
    text: 'Free Trial',
    image: Icons.promotionAlone,
    onClick: 'onOpenFreeTrialOnly',
  },
  items: [
    {
      text: 'Home',
      image: Icons.home,
      path: '/home',
      activeImage: Icons.homeActive,
      onClick: 'toggleMenu',
    },
    {
      text: 'Virtual Mirror',
      image: Icons.vm,
      activeImage: Icons.vmActive,
      path: '/vm',
      onClick: 'showCamPopUp',
    },
    {
      text: 'Lens Care',
      image: Icons.lenscare,
      activeImage: Icons.lenscareActive,
      path: '/about-lens-care',
      onClick: 'toggleMenu',
    },
    {
      text: 'Store Locator',
      image: Icons.store,
      activeImage: Icons.storeActive,
      href: storeLink,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: 'instagram',
      image: Icons.insta,
      activeImage: Icons.instaActive,
      href: instagramLink,
      onClick: 'toggleMenu',
    },
    {
      text: 'Share',
      image: Icons.share,
      activeImage: Icons.shareActive,
      href: facebookLink,
      share: true,
      onClick: 'toggleMenu',
    },
    {
      text: 'Free Trial',
      image: Icons.promotion,
      activeImage: Icons.promotionActive,
      onClick: 'onOpenFreeTrial',
    },
    {
      text: 'Logout',
      condition: isAuthEnable,
      image: Icons.poweroff,
      activeImage: Icons.poweroffActive,
      onClick: 'logout',
    },
  ],
});

export const ThailandHeaderConfig = () => ({
  items: [
    {
      text: 'หน้าแรก',
      image: Icons.home,
      path: '/home',
      activeImage: Icons.homeActive,
      onClick: 'toggleMenu',
    },
    {
      text: 'ทดลองเลนส์',
      image: Icons.vm,
      activeImage: Icons.vmActive,
      path: '/vm',
      onClick: 'showCamPopUp',
    }
  ],
});

export const PhilippinesHeaderConfig = () => ({
  items: [
    {
      text: 'Virtual Mirror',
      image: Icons.vm,
      activeImage: Icons.vmActive,
      path: '/vm',
      onClick: 'showCamPopUp',
    },
    {
      text: 'Lens Care',
      image: Icons.lenscare,
      activeImage: Icons.lenscareActive,
      path: '/about-lens-care',
      onClick: 'toggleMenu',
    }
  ],
});

export const TaiwanHeaderConfig = () => ({
  items: [
    {
      text: '首頁',
      image: Icons.home,
      path: '/home',
      activeImage: Icons.homeActive,
      onClick: 'toggleMenu',
    },
    {
      text: 'Lens Finder',
      image: Icons.lensfinder,
      activeImage: Icons.lensfinderActive,
      onClick: 'toggleMenu',
      condition: showQuiz,
    },
    {
      text: '濾鏡體驗',
      image: Icons.vm,
      activeImage: Icons.vmActive,
      path: '/vm',
      onClick: 'showCamPopUp',
    },
    {
      text: '加入會員',
      image: Icons.promotion,
      activeImage: Icons.promotionActive,
      href: freeTrialLink,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: '門市位置',
      image: Icons.store,
      activeImage: Icons.storeActive,
      href: storeLink,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: 'instagram',
      image: Icons.insta,
      activeImage: Icons.instaActive,
      href: instagramLink,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: '分享濾鏡',
      image: Icons.share,
      activeImage: Icons.shareActive,
      href: facebookLink,
      share: true,
      onClick: 'toggleMenu',
    },
    {
      text: '配戴及保養',
      image: Icons.lenscare,
      activeImage: Icons.lenscareActive,
      href: lensCareLink,
      onClick: 'toggleMenu',
      externalLink: true,
      // subMenus: [
      //   {
      //     text: 'test1',
      //     href: storeLink,
      //     onClick: 'toggleMenu',
      //     externalLink: true,
      //   },
      //   {
      //     text: 'test2',
      //     image: Icons.store,
      //     activeImage: Icons.storeActive,
      //     href: storeLink,
      //     onClick: 'toggleMenu',
      //     externalLink: true,
      //   },
      // ]
    },
    {
      text: 'Logout',
      condition: isAuthEnable,
      image: Icons.poweroff,
      activeImage: Icons.poweroffActive,
      onClick: 'logout',
    },
  ],
});

export const Arabia_EnHeaderConfig = () => ({
  items: [
    {
      text: 'Home',
      image: Icons.home,
      path: '/home',
      activeImage: Icons.homeActive,
      onClick: 'toggleMenu',
    },
    {
      text: 'Virtual Mirror',
      image: Icons.vm,
      activeImage: Icons.vmActive,
      path: '/vm',
      onClick: 'showCamPopUp',
    },
    {
      text: 'Find ECP',
      image: Icons.store,
      activeImage: Icons.storeActive,
      href: process.env.REACT_APP_FIND_ECP,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: 'Lens Care',
      image: Icons.lenscare,
      activeImage: Icons.lenscareActive,
      path: '/about-lens-care',
      onClick: 'toggleMenu',
    },
    {
      text: 'Share',
      image: Icons.shareUniversal,
      activeImage: Icons.shareUniversalActive,
      share: true,
      onClick: 'toggleMenu',
      subMenus: [
      ]
    },
    {
      text: 'العربية',
      image: Icons.appsflyer_icon,
      activeImage: Icons.appsflyer_icon,
      href: redirectToArabic,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: 'Logout',
      condition: isAuthEnable,
      image: Icons.poweroff,
      activeImage: Icons.poweroffActive,
      onClick: 'logout',
    },
  ],
});

export const ArabicHeaderConfig = () => ({
  items: [
    {
      text: 'الرئيسية',
      image: Icons.home,
      path: '/home',
      activeImage: Icons.homeActive,
      onClick: 'toggleMenu',
    },
    {
      text: 'المرآة الافتراضية',
      image: Icons.vm,
      activeImage: Icons.vmActive,
      path: '/vm',
      onClick: 'showCamPopUp',
    },
    {
      text: 'اعثري على أخصائي العيون',
      image: Icons.store,
      activeImage: Icons.storeActive,
      href: process.env.REACT_APP_FIND_ECP,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: 'العناية بالعدسات',
      image: Icons.lenscare,
      activeImage: Icons.lenscareActive,
      path: '/about-lens-care',
      onClick: 'toggleMenu',
    },
    {
      text: 'شارك',
      image: Icons.shareUniversal,
      activeImage: Icons.shareUniversalActive,
      share: true,
      onClick: 'toggleMenu',
      subMenus: [
      ]
    },
    {
      text: 'English',
      image: Icons.appsflyer_icon,
      activeImage: Icons.appsflyer_icon,
      href: redirectToEnglish,
      onClick: 'toggleMenu',
      externalLink:true,
    },
    {
      text: 'تسجيل الخروج',
      condition: isAuthEnable,
      image: Icons.poweroff,
      activeImage: Icons.poweroffActive,
      onClick: 'logout',
    },
  ],
});

export const RussiaHeaderConfig = () => ({
  items: [
    {
      text: 'Главная',
      image: Icons.home,
      path: '/home',
      activeImage: Icons.homeActive,
      onClick: 'toggleMenu',
    },
    {
      text: 'Онлайн примерка',
      image: Icons.vm,
      activeImage: Icons.vmActive,
      path: '/vm',
      onClick: 'showCamPopUp',
    },
    {
      text: 'Карта оптик',
      image: Icons.store,
      activeImage: Icons.storeActive,
      href: process.env.REACT_APP_FIND_ECP,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: 'Уход за линзами',
      image: Icons.lenscare,
      activeImage: Icons.lenscareActive,
      href: process.env.REACT_APP_LENS_CARE,
      onClick: 'toggleMenu',
      externalLink: true,
    },
    {
      text: 'Поделиться',
      image: Icons.shareUniversal,
      activeImage: Icons.shareUniversalActive,
      share: true,
      onClick: 'toggleMenu',
      subMenus: [
        // {
        //   text: 'FB',
        //   image: Icons.share,
        //   activeImage: Icons.share,
        //   href: facebookLink,
        //   onClick: 'toggleMenu'
        // },
        // {
        //   text: 'INSTA',
        //   image: Icons.insta,
        //   activeImage: Icons.instaActive,
        //   href: instagramLink,
        //   onClick: 'toggleMenu'
        // },
        // {
        //   text: 'YOUTUBE',
        //   image: Icons.youtube,
        //   activeImage: Icons.youtube,
        //   href: youtubeLink,
        //   onClick: 'toggleMenu'
        // },        
        // {
        //   text: 'VK',
        //   image: Icons.vk,
        //   activeImage: Icons.vk,
        //   href: vkLink,
        //   onClick: 'toggleMenu'
        // },
      ]
    },
    {
      text: 'Logout',
      condition: isAuthEnable,
      image: Icons.poweroff,
      activeImage: Icons.poweroffActive,
      onClick: 'logout',
    },
  ],
});

export default HeaderConfig;
